var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 122.686V167C17 169.209 18.7908 171 21 171H63V163.975C49.0178 158.503 39.0244 147.656 32.9758 132.679C31.8767 132.89 30.7434 133 29.585 133C22.448 133 18.6379 128.811 17 122.686ZM108 171H151C153.209 171 155 169.209 155 167V122.686C153.362 128.811 149.552 133 142.415 133C141.257 133 140.123 132.89 139.024 132.679C132.832 148.01 122.507 159.015 108 164.354V171Z",
    className: "HairDark"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.088 22.7893C107.041 20.2235 107.013 17.6324 107.004 15.0167C107 13.9121 107.937 13 109.042 13C170.729 13.004 170.999 14.0243 171 168.945C171 170.049 170.094 171.006 168.991 170.946C154.589 170.167 142.305 160.989 132.563 144.937C135.068 141.24 137.221 137.143 139.024 132.679C140.123 132.89 141.257 133 142.415 133C152.586 133 156 124.493 156 114C156 104.83 153.393 97.1774 145.948 95.3929C145.983 94.0451 146 92.6827 146 91.3062C146 53.9227 133.118 30.479 107.088 22.7893Z",
    className: "Hair"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8692 23.1082C63.9419 19.7866 63.9844 16.4223 63.9964 13.0167C64.0003 11.9122 63.0629 10.9999 61.9583 11C0.26818 11.004 0.00115335 12.0374 4.92772e-06 168.945C-3.15674e-06 170.049 0.905998 171.006 2.00891 170.945C16.5941 170.146 29.0064 160.625 38.806 143.986C36.5686 140.541 34.6256 136.763 32.9759 132.679C31.8768 132.89 30.7433 133 29.5849 133C19.4145 133 16 124.493 16 114C16 104.83 18.6075 97.1774 26.0524 95.3929C26.0175 94.0451 26 92.6827 26 91.3062C26 54.4257 38.5382 31.1124 63.8692 23.1082Z",
    className: "Hair"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.984 68.9957C78.7158 68.6181 19.885 43.4135 18.0445 2.01049C17.9954 0.907006 18.9501 -3.99668e-06 20.0547 6.44496e-06C168.139 0.0014063 168.998 0.306857 169 66.9567C169 68.0613 168.088 69.0004 166.984 68.9957Z",
    className: "Hair"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.988 99.99C167.543 61.987 154.444 36.5512 133 35.0685C131.898 34.9923 131 35.9384 131 37.043C131.004 101.054 131.364 101.987 165.974 102C167.079 102 168.001 101.095 167.988 99.99Z",
    className: "Hair"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01171 99.99C3.45665 61.987 16.5557 36.5512 37.9998 35.0685C39.1017 34.9923 40 35.9384 40 37.043C39.9962 101.054 39.6356 101.987 5.02569 102C3.92112 102 2.99878 101.095 3.01171 99.99Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairH);
export default __webpack_public_path__ + "static/media/Hair H.4b863fb77780ee5c190b035e76129d6f.svg";
export { ForwardRef as ReactComponent };